export function generarCSVReporteSesionPOS(data: any) {
    const sesion = data.sesion;
    const csvRows = [];

    // Encabezado
    csvRows.push('Comarca Cowork - Reporte de Sesión POS');
    csvRows.push('');
    
    // Información de la sesión
    csvRows.push('Información de la Sesión:');
    csvRows.push(`Punto de Venta,${sesion.punto_de_venta_nombre || sesion.punto_de_venta}`);
    csvRows.push(`Usuario,${sesion.usuario_nombre || sesion.usuario}`);
    csvRows.push(`Fecha de Apertura,${formatearFecha(sesion.fecha_apertura)}`);
    csvRows.push(`Fecha de Cierre,${sesion.fecha_cierre ? formatearFecha(sesion.fecha_cierre) : "Sesión abierta"}`);
    csvRows.push('');

    // Resumen
    csvRows.push('Resumen:');
    csvRows.push('Ventas,Citas,Total Pagos,Entradas,Salidas');
    csvRows.push([
        data.resumen.ventas_realizadas,
        data.resumen.citas_registradas,
        data.resumen.total_pagos,
        data.resumen.total_entradas,
        data.resumen.total_salidas
    ].join(','));
    csvRows.push('');

    // Movimientos
    if (data.movimientos && data.movimientos.length > 0) {
        csvRows.push('Movimientos de Caja:');
        csvRows.push('ID,Usuario,Tipo,Monto,Descripción,Fecha');
        data.movimientos.forEach((m: any) => {
            csvRows.push([
                m.id,
                `"${(m.usuario_nombre || m.usuario).replace(/"/g, '""')}"`,
                m.tipo,
                m.monto,
                `"${m.descripcion.replace(/"/g, '""')}"`,
                formatearFecha(m.fecha)
            ].join(','));
        });
        csvRows.push('');
    }

    // Pagos
    if (data.pagos && data.pagos.length > 0) {
        csvRows.push('Pagos Recibidos:');
        csvRows.push('ID,Código,Cita,Monto,Tipo de Pago,Fecha');
        data.pagos.forEach((p: any) => {
            csvRows.push([
                p.id,
                p.codigo,
                p.cita,
                p.monto,
                p.tipo_pago_nombre || p.tipo_pago || "",
                formatearFecha(p.fecha_pago)
            ].join(','));
        });
        csvRows.push('');
    }

    // Citas
    if (data.citas && data.citas.length > 0) {
        csvRows.push('Citas Registradas:');
        csvRows.push('ID,Cliente,Código,Estado,Fecha');
        data.citas.forEach((c: any) => {
            const clienteNombre = c.cliente_info 
                ? `${c.cliente_info.first_name} ${c.cliente_info.last_name || ""}`
                : c.cliente_nombre || c.cliente || "";
                
            csvRows.push([
                c.id,
                `"${clienteNombre.replace(/"/g, '""')}"`,
                c.codigo || "",
                c.estado || "",
                formatearFecha(c.fecha_creacion)
            ].join(','));
        });
    }

    // Crear archivo
    const csvContent = csvRows.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    
    link.setAttribute('href', url);
    link.setAttribute('download', `reporte_sesion_pos_${sesion.punto_de_venta_nombre || sesion.punto_de_venta}_${formatearFechaArchivo(sesion.fecha_apertura)}.csv`);
    link.style.visibility = 'hidden';
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

// Helper functions
function formatearFecha(fecha: string): string {
    if (!fecha) return "";
    const d = new Date(fecha);
    return d.toLocaleString("es-MX", { hour12: false });
}

function formatearFechaArchivo(fecha: string): string {
    if (!fecha) return "";
    const d = new Date(fecha);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
        d.getDate()
    ).padStart(2, "0")}_${String(d.getHours()).padStart(2, "0")}${String(d.getMinutes()).padStart(2, "0")}`;
}